<template>
  <v-tooltip max-width="400" content-class="schedule-info-tooltip">
    <template #activator="{ props: tooltipProps }">
      <v-icon v-bind="tooltipProps" size="16" style="color: #000"> mdi-information-outline </v-icon>
    </template>
    <div style="padding: 16px">
      <div style="font-weight: 600; margin-bottom: 8px; color: #333; font-size: 16px">Session-based</div>
      <div style="font-size: 14px; line-height: 1.5; margin-bottom: 16px; color: #666">
        A structured experience with defined start and end dates. Learn alongside peers and stay on track with weekly
        deadlines.
      </div>
      <div style="font-weight: 600; margin-bottom: 8px; color: #333; font-size: 16px">On-demand</div>
      <div style="font-size: 14px; line-height: 1.5; color: #666">
        Start immediately and move through the course at your own pace. Minimum six week enrollment period and one year
        to complete the course.
      </div>
    </div>
  </v-tooltip>
</template>

<style>
.schedule-info-tooltip {
  background-color: #f5f5f5 !important;
  border: 1px solid #e0e0e0 !important;
  border-radius: 8px !important;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15) !important;
}

.schedule-info-tooltip .v-overlay__content {
  background-color: #f5f5f5 !important;
}
</style>
